import { apiGet, apiGetText } from "./Api/apiCall";
import { fetchCollection } from "./ReactQuery/reactQueryService";
import { HydraCollectionResult } from "../types/HydraCollectionResult";
import { MediaObject } from "../types/MediaObject";

export const MEDIA_OBJECT_TO_TEXT_RESULTS_PER_PAGE = 50;

export const fetchMediaObjectsWithTextResult = async (
  page: number,
  caseFilter: Pick<MediaObject, "product" | "productId"> | null = null,
  signal?: AbortSignal,
): Promise<HydraCollectionResult<MediaObject>> => {
  return await fetchCollection(
    "media_objects",
    {
      "exists[mediaObjectToTextResultUrl]": "true",
      "order[created]": "desc",
      "order[id]": "desc",
      ...(caseFilter ?? {}),
      page,
      itemsPerPage: MEDIA_OBJECT_TO_TEXT_RESULTS_PER_PAGE,
    },
    { signal },
  );
};

export const fetchMediaObjectForTextComparison = async (
  mediaObjectId: number,
  signal?: AbortSignal,
): Promise<MediaObject> => {
  return await apiGet<MediaObject>("media_objects", mediaObjectId, {}, { signal });
};

export const fetchMediaObjectTextResult = async (mediaObjectId: number, signal?: AbortSignal): Promise<string> => {
  return await apiGetText(`/lb/media_objects/${mediaObjectId}/markdown`, { signal });
};
